import { render, staticRenderFns } from "./ProjectHeader.vue?vue&type=template&id=605dab54&scoped=true&"
import script from "./ProjectHeader.vue?vue&type=script&lang=ts&"
export * from "./ProjectHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectHeader.vue?vue&type=style&index=0&id=605dab54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605dab54",
  null
  
)

export default component.exports